import { IApiCollectionItemFolderChild } from "@propely/propely-typings";
import { PathSegment } from "@src/data-hooks/documentation-collection/useDocumentationCollection";
import { usePropertyCollectionItemFolders } from "@src/data-hooks/property/collection/collectionItem/propertyCollectionItem.service";
import { useState } from "react";
import styles from "./SubFolderDropdown.module.css";
import { Icon } from "@src/components/deprecated/Icon/Icon";
import { Text } from "@src/components/deprecated/Text/Text";
import { Spacer } from "@src/components/ui-components/Spacer/Spacer";

interface SubFolderDropdownProps {
  collectionId: string;
  propertyId: string;
  collectionItemId: string;
  parentFolderId?: string;
  folders?: IApiCollectionItemFolderChild[];
  onSelectFolder: (relativeId: string, folderPath: PathSegment | undefined) => void;
  selectedFolder: string | null;
  setSelectedFolder: (folderId: string | null) => void;
}

const SubFolderDropdown = ({
  collectionId,
  propertyId,
  collectionItemId,
  parentFolderId,
  folders,
  onSelectFolder,
  selectedFolder,
  setSelectedFolder,
}: SubFolderDropdownProps) => {
  const { data } = usePropertyCollectionItemFolders({
    collectionId,
    propertyId,
    folderId: parentFolderId,
    itemId: collectionItemId,
  });

  const [expandedFolders, setExpandedFolders] = useState<{ [key: string]: boolean }>({});

  const toggleFolder = (folderId: string) => {
    setExpandedFolders((prev) => ({
      ...prev,
      [folderId]: !prev[folderId],
    }));
  };

  const handleSelectFolder = (folderId: string, folderPath: PathSegment) => {
    if (selectedFolder === folderId) {
      setSelectedFolder(null);
      onSelectFolder(collectionItemId, undefined);
      return;
    }
    setSelectedFolder(folderId);
    onSelectFolder(collectionItemId, folderPath);
  };

  const filteredFolders: IApiCollectionItemFolderChild[] = folders ?? data?.folders ?? [];
  return (
    <div className={styles.subFolderDropdown}>
      {filteredFolders.map((folder: IApiCollectionItemFolderChild) => (
        <div key={folder.id}>
          <div className={styles.row}>
            <Text size="md">{folder.name}</Text>
            <Spacer />
            <Icon
              onClick={() => handleSelectFolder(folder.id, { id: folder.id, name: folder.name })}
              name={selectedFolder === folder.id ? "check_box" : "check_box_outline_blank"}
            />
            {folder.subFolders && folder.subFolders.length > 0 && (
              <Icon name={expandedFolders[folder.id] ? "expand_more" : "chevron_right"} onClick={() => toggleFolder(folder.id)} />
            )}
          </div>
          {expandedFolders[folder.id] && (
            <SubFolderDropdown
              collectionId={collectionId}
              propertyId={propertyId}
              collectionItemId={collectionItemId}
              parentFolderId={folder.id}
              folders={folder.subFolders} // Pass subfolders for recursive rendering
              onSelectFolder={onSelectFolder}
              selectedFolder={selectedFolder} // Pass down selected folder state
              setSelectedFolder={setSelectedFolder} // Pass down setter function
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SubFolderDropdown;
